import React, { Component } from 'react';

import { Form, Row, Col, Button, Modal , Card , Spin } from 'antd';

import components from './../components';
import layouts from './../layouts';
import fetch from '../services/fetch';
import service from './../services';
import utils from './../utils';

class employeePwd extends Component {
    constructor(props) {
        super(props);

        this.state = {
            newPwd : '' ,
            pwd : '',
        }
    }

    componentDidMount(){
        service.sysparam.passwordComplexity().then(data => {
            this.setState({
                complexity: data.complexity,
                message: data.message,
                isOpen: data.isOpen
            });
        })
    }

    onSubmit(event) {
        event.preventDefault();

        this.props.form.validateFields((error, values) => {
            
            if(!error) {
                if((values.newPwd !== values.pwd)) {
                    Modal.error({
                        title: "设置密码",
                        content: "两次密码不一致！！",
                        okText: "确定"
                    });
                } else if(values.length < 8) {
                    Modal.error({
                        title: "设置密码",
                        content: "密码长度不能小于8位！！",
                        okText: "确定"
                    });
                } else {
                    fetch.post('employee/resetpwd/login',{
                        oldPwd: md5(values.oldPwd),
                        newPwd: md5(values.newPwd),
                    })
                    .then(response => {
                        
                        if(response.code === 200) {
                            const responseData = this.transform(response)
                            return responseData;
                        }else {
                            return {
                                success: false,
                                message: response.message
                            };
                        }
                    })
                    .then(data => {
                        if(data.success) {
                            const saveSession = this.saveSession(data);
                            return saveSession;
                        }
                    })
                    .then(payload => {
                        window.location.hash = '/';
                        if(payload) {
                            this.props.updateAccount(payload);
                        }
                    })
                }
            }
        });
    }

    transform (response) {
        const data = response.payload.data;
        return {
            success: true,
            code: response.code,
            message: response.message,
            payload: {
            account: {
                id: data.employeeId,
                loginName: data.loginName,
                realName: data.realName,
                schoolName: data.schoolName,
                termName: data.termName,
                yearName: data.yearName,
                termId: data.termId,
                yearId: data.yearId,
                dudao: data.dudao,
                systemName: data.systemName
            },
            rules: data.roleModuleList.map((rule) => {
                return {
                    id: rule.id,
                    name: rule.name,
                    pid: rule.pid,
                    url: rule.url,
                    depth: rule.level,
                    icon: rule.icon,
                    label: rule.label,
                    orderNum: rule.orderNum
                }
            }),
            roleIds: data.roleIds,
            operationList: data.operationList,
            show: data.display
            }
        };
    }

    saveSession (data) {
        var result = utils.tree(data.payload.rules);
        const operation = {};
    
        data.payload.operationList.forEach(item => {
            operation[item.operationUrl] = {
                name: item.operationName,
                enabled: item.enabled,
                show: data.payload.show
            }
        });
    
        window.sessionStorage.setItem('session', JSON.stringify({
            account: data.payload.account,
            rules: result[0].children,
            roleIds: data.payload.roleIds,
            operation: operation
        }));
        
        return data.payload;
    }

    handleChange(data){
        const domain = Object.assign({} , this.state , data )
        this.setState({
            domain
        })
    }

    validateToPassword (rule, value, callback){
        if (value && value.indexOf("_") != -1) {// 特殊字符不包含"_"
            callback('不能包含"_"')
        }else{
            callback();
        }
    }

    render() {
        const props  = this.props;
        
        const {getFieldDecorator} = props.form;
        const formItemLayout = {
            labelCol: {
                xs: 24,
                sm: { span: 2 }

            },
            wrapperCol: {
                xs: 24,
                sm: { 
                    span: 16, 
                    offset: 1
                 }
            }
        }
        return (
        <div className="div-employee-pwd">
                <Form layout="horizontal" {...formItemLayout}  className="register-card-form"  onSubmit={this.onSubmit.bind(this)}>
                    <Card  style={{marginBottom : 20}} className="div-register-card">
                            <h2 style={{textAlign :'center'}}>修改密码</h2>
                            <div className="root-form-body">
                                {/* <Row>
                                    <Col span="12"><components.Input actionDisable={true} name="loginName" label="登陆名" getFieldDecorator={getFieldDecorator} value={this.state.loginName} /></Col>
                                    <Col span="12"></Col>
                                </Row> */}
                                <Row  gutter={24}>
                                    <Col span="24"><components.Input type="password" name="oldPwd" label="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;旧密码" getFieldDecorator={getFieldDecorator}
                                        rules ={[
                                            { required: true, message: '请输入旧密码！'}
                                        ]}
                                        value={this.state.oldPwd} handleChange={this.handleChange.bind(this)} /></Col>
                                </Row>
                                <Row  gutter={24}>
                                    <Col span="24"><components.Input type="password"  name="newPwd" label="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;新密码" getFieldDecorator={getFieldDecorator}
                                    rules={this.state.isOpen ? [
                                        // { pattern:  /(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9])/,message:'必须有数字、字母及特殊字符组合'}
                                        { required: true, message: '请输入密码' }, 
                                        {validator: this.validateToPassword.bind(this)},
                                        { pattern: this.state.complexity ? this.state.complexity : /^(?![A-Za-z0-9]+$)(?![a-z0-9\W]+$)(?![A-Za-z\W]+$)(?![A-Z0-9\W]+$)[a-zA-Z0-9\W]{8,30}$/, message: this.state.message ? this.state.message : '必须是包含数字、大写字母、小写字母及特殊字符组合,长度在8~30' }, 
                                        ] 
                                        : [
                                        { required: true, message: '请输入密码' },
                                        { min: 8, message: '必须大于8个字符' },
                                        { max: 30, message: '不得超过30个字符' }, 
                                        {validator: this.validateToPassword.bind(this)}
                                        ]
                                    } 
                                    value={this.state.newPwd} handleChange={this.handleChange.bind(this)} /></Col>
                                </Row>

                                <Row  gutter={24}>
                                    <Col span="24"><components.Input type="password"  name="pwd" label="确认新密码" getFieldDecorator={getFieldDecorator} value={this.state.pwd} handleChange={this.handleChange.bind(this)} /></Col>
                                </Row>
                            </div>

                            <div style={{float : 'right'}}>
                                <Button htmlType="submit" type="primary">确认</Button>
                            </div>
                        </Card>
                    </Form>
            </div>
        )
    }
}

export default Form.create()(employeePwd);